/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {annotations, Code} from "@code-hike/mdx/dist/components.cjs.js";
export const CH = {
  annotations,
  Code
};
export const chCodeConfig = {
  "staticMediaQuery": "not screen, (max-width: 768px)",
  "lineNumbers": undefined,
  "showCopyButton": true,
  "themeName": "dark-plus"
};
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ol: "ol",
    li: "li",
    code: "code",
    ul: "ul",
    span: "span",
    h2: "h2",
    a: "a"
  }, _provideComponents(), props.components), {Video} = _components;
  if (!CH) _missingMdxReference("CH", false);
  if (!CH.Code) _missingMdxReference("CH.Code", true);
  if (!Video) _missingMdxReference("Video", true);
  return React.createElement(React.Fragment, null, React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-ch-theme=\"dark-plus\"] {  --ch-t-colorScheme: var(--ch-0);--ch-t-foreground: var(--shiki-token-embed);--ch-t-background: var(--shiki-background-editor);--ch-t-editor-background: var(--shiki-background-editor);--ch-t-editor-foreground: var(--shiki-token-embed);--ch-t-tab-activeBackground: var(--shiki-background-editor);--ch-t-tab-inactiveBackground: var(--shiki-background-editor);--ch-t-tab-border: var(--shiki-menu-background);--ch-t-tab-activeBorder: var(--shiki-background-editor);--ch-t-editorGroupHeader-tabsBackground: var(--shiki-background-header);--ch-t-input-foreground: var(--shiki-token-embed);--ch-t-sideBar-foreground: var(--shiki-token-embed); }"
    }
  }), "\n", React.createElement(_components.p, null, "Dark mode has become increasingly popular in recent years, as it can help reduce eyestrain and save battery life on devices. If you have a website or an app, you may want to track whether your users are using dark mode so that you can better understand their preferences and tailor your content accordingly."), "\n", React.createElement(_components.p, null, "To track the user's dark mode setting, we will use Google Analytics 4 (GA4) and Google Tag Manager (GTM). This process will include the configuration of GTM, the creation of a custom dimension in GA, and, finally, setting up a report for gained data."), "\n", React.createElement(_components.p, null, "Here are the steps to create a custom variable in GTM to track the user's dark and light theme setting:"), "\n", React.createElement(Video, {
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true,
    width: "1528",
    height: "1080"
  }, React.createElement("source", {
    type: "video/mp4",
    src: "https://pixel-point-website.s3.amazonaws.com/posts/2022-12-12-how-to-track-user-dark-and-light-mode-in-ga4/video-1.mp4"
  }), React.createElement("source", {
    type: "video/webm",
    src: "https://pixel-point-website.s3.amazonaws.com/posts/2022-12-12-how-to-track-user-dark-and-light-mode-in-ga4/video-1.webm"
  })), "\n", React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "In your GTM account, go to the \"Variables\" section and click on the \"New\" button."), "\n", React.createElement(_components.li, null, "On the \"Create Variable\" page, select \"Custom JavaScript\" as the variable type and name it “User Color Mode”."), "\n", React.createElement(_components.li, null, "In the \"Custom JavaScript\" field, enter a function that returns either \"dark\" or \"light\" depending on the user's dark mode setting."), "\n", React.createElement(_components.li, null, "Click on the \"Save\" button to save the custom variable."), "\n"), "\n", React.createElement(CH.Code, {
    codeConfig: chCodeConfig,
    northPanel: {
      "tabs": [""],
      "active": "",
      "heightRatio": 1
    },
    files: [{
      "name": "",
      "focus": "",
      "code": {
        "lines": [{
          "tokens": [{
            "content": "  function",
            "props": {
              "style": {
                "color": "var(--shiki-token-keyword)"
              }
            }
          }, {
            "content": " () {",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }, {
          "tokens": [{
            "content": "    if",
            "props": {
              "style": {
                "color": "var(--shiki-token-keyword)"
              }
            }
          }, {
            "content": " (",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "window",
            "props": {
              "style": {
                "color": "var(--shiki-color-text)"
              }
            }
          }, {
            "content": ".",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "matchMedia ",
            "props": {
              "style": {
                "color": "var(--shiki-color-text)"
              }
            }
          }, {
            "content": "&& ",
            "props": {
              "style": {
                "color": "var(--shiki-token-keyword)"
              }
            }
          }, {
            "content": "window",
            "props": {
              "style": {
                "color": "var(--shiki-color-text)"
              }
            }
          }, {
            "content": ".",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "matchMedia",
            "props": {
              "style": {
                "color": "var(--shiki-token-function)"
              }
            }
          }, {
            "content": "(",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "'(prefers-color-scheme: dark)'",
            "props": {
              "style": {
                "color": "var(--shiki-token-string)"
              }
            }
          }, {
            "content": ").",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "matches",
            "props": {
              "style": {
                "color": "var(--shiki-color-text)"
              }
            }
          }, {
            "content": ") {",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }, {
          "tokens": [{
            "content": "      return ",
            "props": {
              "style": {
                "color": "var(--shiki-token-keyword)"
              }
            }
          }, {
            "content": "'Dark'",
            "props": {
              "style": {
                "color": "var(--shiki-token-string)"
              }
            }
          }, {
            "content": ";",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }, {
          "tokens": [{
            "content": "    }",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }, {
          "tokens": [{
            "content": "    else if",
            "props": {
              "style": {
                "color": "var(--shiki-token-keyword)"
              }
            }
          }, {
            "content": " (",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "window",
            "props": {
              "style": {
                "color": "var(--shiki-color-text)"
              }
            }
          }, {
            "content": ".",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "matchMedia ",
            "props": {
              "style": {
                "color": "var(--shiki-color-text)"
              }
            }
          }, {
            "content": "&& ",
            "props": {
              "style": {
                "color": "var(--shiki-token-keyword)"
              }
            }
          }, {
            "content": "window",
            "props": {
              "style": {
                "color": "var(--shiki-color-text)"
              }
            }
          }, {
            "content": ".",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "matchMedia",
            "props": {
              "style": {
                "color": "var(--shiki-token-function)"
              }
            }
          }, {
            "content": "(",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "'(prefers-color-scheme: light)'",
            "props": {
              "style": {
                "color": "var(--shiki-token-string)"
              }
            }
          }, {
            "content": ").",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }, {
            "content": "matches",
            "props": {
              "style": {
                "color": "var(--shiki-color-text)"
              }
            }
          }, {
            "content": ") {",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }, {
          "tokens": [{
            "content": "      return ",
            "props": {
              "style": {
                "color": "var(--shiki-token-keyword)"
              }
            }
          }, {
            "content": "'Light'",
            "props": {
              "style": {
                "color": "var(--shiki-token-string)"
              }
            }
          }, {
            "content": ";",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }, {
          "tokens": [{
            "content": "    }",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }, {
          "tokens": [{
            "content": "    return ",
            "props": {
              "style": {
                "color": "var(--shiki-token-keyword)"
              }
            }
          }, {
            "content": "'No Preference'",
            "props": {
              "style": {
                "color": "var(--shiki-token-string)"
              }
            }
          }, {
            "content": ";",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }, {
          "tokens": [{
            "content": "  }",
            "props": {
              "style": {
                "color": "var(--shiki-token-embed)"
              }
            }
          }]
        }],
        "lang": "jsx"
      },
      "annotations": []
    }]
  }), "\n", React.createElement(_components.p, null, "Note: ", React.createElement(_components.code, null, "window.matchMedia('(prefers-color-scheme: dark)')"), " shows user preference through an operating system setting (e.g., light or dark mode) or a user agent setting. If you want to track it based on the user’s selected option in your app, you can extend this approach by adding the GA user data programmatically.(GA docs)"), "\n", React.createElement(_components.p, null, "Once you have created the custom variable in GTM to track the user's dark mode setting, you can create a custom tag in GTM that sends the data to GA4 as an event. To create a custom tag in GTM, follow these steps:"), "\n", React.createElement(Video, {
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true,
    width: "1528",
    height: "1080"
  }, React.createElement("source", {
    type: "video/mp4",
    src: "https://pixel-point-website.s3.amazonaws.com/posts/2022-12-12-how-to-track-user-dark-and-light-mode-in-ga4/video-2.mp4"
  }), React.createElement("source", {
    type: "video/webm",
    src: "https://pixel-point-website.s3.amazonaws.com/posts/2022-12-12-how-to-track-user-dark-and-light-mode-in-ga4/video-2.webm"
  })), "\n", React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "In your GTM account, go to the \"Tags\" section and click on the \"New\" button."), "\n", React.createElement(_components.li, null, "In the \"Create Tag\" page, select \"Google Analytics: GA4 Event\" as the tag type."), "\n", React.createElement(_components.li, null, "In the \"Google Analytics Settings\" section, select the correct GA4 property from the \"Configuration Tag\" dropdown. Make sure that you’ve selected the property that corresponds to your website or app."), "\n", React.createElement(_components.li, null, "In the \"Event Parameters\" section, enter the following values:", "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "Event name: \"page_view\""), "\n", React.createElement(_components.li, null, "Event parameters: ", React.createElement(_components.code, null, "{ \"color_mode\": {{User Color Mode}} }")), "\n"), "\n"), "\n", React.createElement(_components.li, null, "Add trigger “Initialization - All pages”"), "\n", React.createElement(_components.li, null, "Press “Save”"), "\n"), "\n", React.createElement(_components.p, null, "Now to see the results in Google Analytics(GA4) we need to add custom dimension. You can create a custom dimension named \"User Color Mode\" with a user property value of \"color_mode.\" Here are the steps to do this:"), "\n", React.createElement(Video, {
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true,
    width: "1528",
    height: "1080"
  }, React.createElement("source", {
    type: "video/mp4",
    src: "https://pixel-point-website.s3.amazonaws.com/posts/2022-12-12-how-to-track-user-dark-and-light-mode-in-ga4/video-3.mp4"
  }), React.createElement("source", {
    type: "video/webm",
    src: "https://pixel-point-website.s3.amazonaws.com/posts/2022-12-12-how-to-track-user-dark-and-light-mode-in-ga4/video-3.webm"
  })), "\n", React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "Sign in to your Google Analytics account and navigate to the Configure section."), "\n", React.createElement(_components.li, null, "Click on Custom Definitions, then click on Custom Dimensions."), "\n", React.createElement(_components.li, null, "Click the \"New Custom Dimension\" button."), "\n", React.createElement(_components.li, null, "In the \"Name\" field, enter \"User Color Mode\" as the name of the custom dimension."), "\n", React.createElement(_components.li, null, "In the \"Scope\" field, select \"User\" as the scope for this custom dimension. This will allow the dimension to be associated with individual users of your website."), "\n", React.createElement(_components.li, null, "In the \"Event Parameter\" field, enter \"color_mode\" as the event parameter that will set the value of this custom dimension."), "\n", React.createElement(_components.li, null, "In the \"Active\" field, make sure you’ve checked the box to enable this custom dimension."), "\n", React.createElement(_components.li, null, "Click the \"Create\" button to save the new custom dimension."), "\n"), "\n", React.createElement(_components.p, null, "Once you've set up, you can immediately view the statistics on the \"Reports\" → \"Realtime\" page. However, on other pages such as \"Explore,\" you'll need to wait 24 hours before you can start using this new user property."), "\n", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<span\n      class=\"gatsby-resp-image-wrapper\"\n      style=\"position: relative; display: block; margin-left: auto; margin-right: auto; max-width: 696px; \"\n    >\n      <span\n    class=\"gatsby-resp-image-background-image\"\n    style=\"padding-bottom: 71.26436781609195%; position: relative; bottom: 0; left: 0; background-image: url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABYBAQEBAAAAAAAAAAAAAAAAAAIAA//aAAwDAQACEAMQAAABcYlMummRuv/EABoQAAIDAQEAAAAAAAAAAAAAAAIDAAEEBRT/2gAIAQEAAQUCQkCR51zYNA9O4FqroBc0tprf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAGBEAAgMAAAAAAAAAAAAAAAAAAAECISL/2gAIAQIBAT8B0RdH/8QAHRAAAgIBBQAAAAAAAAAAAAAAAQIAERIhMTIzUf/aAAgBAQAGPwJCVG3k61lKKFRVKtoJwaZAVP/EABgQAAMBAQAAAAAAAAAAAAAAAAABESHh/9oACAEBAAE/IXYbeqNSnNBiGDTlVDhBZZIlp//aAAwDAQACAAMAAAAQ5N//xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQMBAT8QxWC//8QAFxEBAQEBAAAAAAAAAAAAAAAAAREAIf/aAAgBAgEBPxCp46Au/8QAHBABAQEAAQUAAAAAAAAAAAAAAREAIVFhcaHR/9oACAEBAAE/EBHTVRXzccJn1mbUqjC4YjGkPvCMCd/rI+BJN43/2Q=='); background-size: cover; display: block;\"\n  ></span>\n  <picture>\n          <source\n              srcset=\"/static/20261ae1a2387f0a90eb053e7652d66b/09400/screenshot-1.webp 174w,\n/static/20261ae1a2387f0a90eb053e7652d66b/3266f/screenshot-1.webp 348w,\n/static/20261ae1a2387f0a90eb053e7652d66b/657d2/screenshot-1.webp 696w,\n/static/20261ae1a2387f0a90eb053e7652d66b/e644e/screenshot-1.webp 1044w,\n/static/20261ae1a2387f0a90eb053e7652d66b/8daba/screenshot-1.webp 1392w,\n/static/20261ae1a2387f0a90eb053e7652d66b/bf8d8/screenshot-1.webp 3496w\"\n              sizes=\"(max-width: 696px) 100vw, 696px\"\n              type=\"image/webp\"\n            />\n          <source\n            srcset=\"/static/20261ae1a2387f0a90eb053e7652d66b/f52d2/screenshot-1.jpg 174w,\n/static/20261ae1a2387f0a90eb053e7652d66b/14ab8/screenshot-1.jpg 348w,\n/static/20261ae1a2387f0a90eb053e7652d66b/a4476/screenshot-1.jpg 696w,\n/static/20261ae1a2387f0a90eb053e7652d66b/4ef30/screenshot-1.jpg 1044w,\n/static/20261ae1a2387f0a90eb053e7652d66b/16454/screenshot-1.jpg 1392w,\n/static/20261ae1a2387f0a90eb053e7652d66b/aa759/screenshot-1.jpg 3496w\"\n            sizes=\"(max-width: 696px) 100vw, 696px\"\n            type=\"image/jpeg\"\n          />\n          <img\n            class=\"gatsby-resp-image-image\"\n            src=\"/static/20261ae1a2387f0a90eb053e7652d66b/a4476/screenshot-1.jpg\"\n            alt=\"\"\n            title=\"\"\n            loading=\"lazy\"\n            decoding=\"async\"\n            style=\"width:100%;height:100%;margin:0;vertical-align:middle;position:absolute;top:0;left:0;\"\n          />\n        </picture>\n    </span>"
    }
  }), "\n", React.createElement(_components.h2, {
    id: "summary"
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#summary"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), "Summary"), "\n", React.createElement(_components.p, null, "Now you know how to set up Google Analytics 4 and GTM in order to track the user’s dark or light theme setting. Analysis of this data can help you define whether it’s important to implement dark mode for the website or app for your audience."), "\n", React.createElement(_components.p, null, "If you enjoyed the article and want to see more web tips, ", React.createElement(_components.a, {
    href: "https://twitter.com/alex_barashkov"
  }, "follow me on Twitter"), "."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
